// extracted by mini-css-extract-plugin
export var filterIncDec = "_ge-0";
export var leftBorder = "_ge-1";
export var rightBorder = "_ge-2";
export var stringInput = "_ge-3";